import { getProjectId } from "./isContactedProject";

export const PROJECT_CONTACTED_EVENT = "proppins:project-contacted";

/** Call after successful authenticated lead submit to optimistically mark contacted. */
export function notifyLeadSubmitSuccess(projectOrId) {
  if (typeof window === "undefined") return;
  const id =
    projectOrId != null && typeof projectOrId === "object"
      ? getProjectId(projectOrId)
      : projectOrId != null
        ? String(projectOrId).trim()
        : null;
  if (!id) return;
  window.dispatchEvent(
    new CustomEvent(PROJECT_CONTACTED_EVENT, { detail: { projectId: id } }),
  );
}
